import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService.js';

const ZONALES = ['NORTE', 'SUR'];
const tipos = [
  { code: 'O', label: 'Venta' },
  { code: 'I', label: 'Compra' },
  { code: 'C', label: 'Cobertura' },
];

// Winter = CIA NACIONAL DE CHOCOLATES.
const WINTER_BP_ID = 17;

export default WithApp(function ModalCuotaZonal(props) {
  const cuota = props.model;
  const periodo = moment(cuota.valueSearch?.Periodo).format('YYYY-MM');

  const [dataChanging, setDataChanging] = useState([]);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (cuota.open) {
      setDataChanging({
        ...(cuota.zonal ? { zonal: cuota.zonal } : {}),
        type: cuota.type,
      });
    }
  }, [cuota.open]);

  return (
    <>
      <Modal
        title={`Nueva cuota de zonal winter`}
        model={cuota}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/winter_quota_zones'
        dataForce={{
          zonal: dataChanging.zonal,
          type: dataChanging.type,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={ZONALES}
          getOptionLabel={(item) => `${item}`}
          renderInput={(params) => (
            <TextField {...params} label="Zonal" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('zonal', item); }}
          value={ZONALES.find((z) => z === dataChanging.zonal) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={tipos}
          getOptionLabel={(item) => item.label}
          renderInput={(params) => (
            <TextField {...params} label="Tipo" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('type', item?.code); }}
          value={tipos.find((t) => t.code === dataChanging.type) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!cuota ? cuota.quota : ''}
          required
        />
      </Modal>
    </>
  );
});
